import React from 'react'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'

export default class MultiCheckOutModal extends React.Component {
  state = {
    outTime: moment(),
  }

  handleOutTimeChange = (e) => {
    const timeString = e.target.value
    if (timeString) {
      const outTime = moment(timeString, 'HH:mm')
      this.setState({ outTime })
    }
  }

  handleCheckOut = () => {
    const { serviceTxnsToCheckout, onCheckOut } = this.props
    onCheckOut(serviceTxnsToCheckout, this.state.outTime)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isShow !== this.props.isShow) {
      this.setState({ outTime: moment() })
    }
  }

  render() {
    const { isShow, onHide, serviceTxnsToCheckout } = this.props
    const label = I18n.t('stationReportScene.checkOutModal')

    if (!isShow) return null

    return (
      <div>
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50"
          onClick={onHide}
        />

        {/* Modal */}
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
              <h2 className="text-xl font-bold text-gray-900">
                Multi Checkout
              </h2>
              <button
                onClick={onHide}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="px-6 py-4">
              {renderModalBody(
                serviceTxnsToCheckout,
                label,
                this.state.outTime,
                this.handleOutTimeChange,
              )}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50">
              <button
                onClick={onHide}
                className="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-100 transition-colors"
              >
                {I18n.t('action.cancel')}
              </button>
              <button
                onClick={this.handleCheckOut}
                className="px-6 py-2.5 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors shadow-sm"
              >
                {I18n.t('action.save')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const renderModalBody = (
  serviceTxnsToCheckout,
  label,
  outTime,
  onOutTimeChange,
) => {
  if (serviceTxnsToCheckout) {
    const passengerAmount = serviceTxnsToCheckout.length
    const isPassengerPural = passengerAmount > 1
    return (
      <div className="space-y-4">
        {/* Checkout For */}
        <div className="grid grid-cols-3 gap-4">
          <div className="text-sm font-medium text-gray-700">Checkout for</div>
          <div className="col-span-2 text-base text-gray-900">
            {serviceTxnsToCheckout.length} passenger{isPassengerPural && 's'}
          </div>
        </div>

        {/* Out Time */}
        <div className="grid grid-cols-3 gap-4">
          <div className="text-sm font-medium text-gray-700">
            {label.outTime}
          </div>
          <div className="col-span-2">
            <input
              type="time"
              value={outTime ? outTime.format('HH:mm') : ''}
              onChange={onOutTimeChange}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-base"
            />
          </div>
        </div>
      </div>
    )
  }
  return null
}
